import { gql, useMutation } from '@apollo/client';

const ACTIVATE_TENANT_BILLING = gql`
  mutation ActivateTenantBilling($tenantCompanyId: String!) {
    activateTenantBilling(tenantCompanyId: $tenantCompanyId) {
      id
      billingActive
    }
  }
`;

export interface ActivateTenantBillingInput {
  tenantCompanyId: string;
}

export interface ActivateTenantBillingResult {
  activateTenantBilling: {
    id: string;
    billingActive: boolean;
  };
}

export function useActivateTenantBillingMutation() {
  return useMutation<ActivateTenantBillingResult, ActivateTenantBillingInput>(ACTIVATE_TENANT_BILLING, {
    refetchQueries: ['GetUser', 'GetUserTenants'],
  });
}
